export default value => {
  return value.replace(/[,.]/g, m => (m === ',' ? '.' : ','))
}
